import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  getPharmaAuditDesk,
  getPharmaAuditHome,
  getPharmaClients,
  getPharmaInterventions,
  getPharmaMaintenances,
  getPharmaMercurials,
  getPharmaPatients,
} from "../../../actions/stats/stats";

class StatsPharma extends React.Component {
  render() {
    const links = [
      {
        fileName: "pharma_clients_par_pharmacies",
        onExport: this.props.onGetPharmaClients,
        formattedMessage: "Nb.Clients.By.Pharmacy",
      },
      {
        fileName: "pharma_patients_par_pharmacies",
        onExport: this.props.onGetPharmaPatients,
        formattedMessage: "Nb.Patients.By.Pharmacy",
      },
      {
        fileName: "pharma_mercuriales_par_pharmacies",
        onExport: this.props.onGetPharmaMercurials,
        formattedMessage: "Nb.Mercurials.By.Pharmacy",
      },
      {
        fileName: "pharma_interventions_par_pharmacies",
        onExport: this.props.onGetPharmaInterventions,
        formattedMessage: "Nb.Interventions.By.Pharmacy",
      },
      {
        fileName: "pharma_maintenances_par_pharmacies",
        onExport: this.props.onGetPharmaMaintenances,
        formattedMessage: "Nb.Maintenances.By.Pharmacy",
      },
      {
        fileName: "pharma_audits_home_par_pharmacies",
        onExport: this.props.onGetPharmaAuditHome,
        formattedMessage: "Nb.Audit.Home.By.Pharmacy",
      },
      {
        fileName: "pharma_audit_desk_par_pharmacies",
        onExport: this.props.onGetPharmaAuditDesk,
        formattedMessage: "Nb.Audit.Desk.By.Pharmacy",
      },
    ];

    const linksNode = links.map((link, index) => {
      return (
        <li key={index}>
          <button
            className="btn btn-link"
            onClick={() =>
              this.props.openConfModal(link.fileName, (successCallback) =>
                link.onExport(successCallback),
              )
            }
          >
            <FormattedMessage id={link.formattedMessage} />
          </button>
        </li>
      );
    });

    return (
      <div>
        <ul style={{ listStyleType: "none" }}>{linksNode}</ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetPharmaClients: (successCallback) =>
      dispatch(getPharmaClients(successCallback)),
    onGetPharmaPatients: (successCallback) =>
      dispatch(getPharmaPatients(successCallback)),
    onGetPharmaMercurials: (successCallback) =>
      dispatch(getPharmaMercurials(successCallback)),
    onGetPharmaInterventions: (successCallback) =>
      dispatch(getPharmaInterventions(successCallback)),
    onGetPharmaMaintenances: (successCallback) =>
      dispatch(getPharmaMaintenances(successCallback)),
    onGetPharmaAuditHome: (successCallback) =>
      dispatch(getPharmaAuditHome(successCallback)),
    onGetPharmaAuditDesk: (successCallback) =>
      dispatch(getPharmaAuditDesk(successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(StatsPharma));
